import React from 'react'
import EditIcon from '../../../Icons/EditIcons'
import { Link } from 'react-router-dom'

const TableActionButton = (props:any) => {
  return (
    <Link to={props?.editPath} className='cursor-pointer'>
      <EditIcon color={"var(--primary)"}/>
    </Link>
  )
}

export default TableActionButton
